// extracted by mini-css-extract-plugin
export default {"root":"_2uN43zExEi","floatAbove":"_2gQ0j5OHC8"};